var _rect, _path, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeStore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#CCECE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 15C34.0066 15 37.7735 16.5603 40.6066 19.3934C41.3784 20.1652 42.0557 21.0063 42.6328 21.9026L41.1009 22.787C38.7362 19.1601 34.6434 16.7578 30 16.7578C22.6982 16.7578 16.7578 22.6982 16.7578 30C16.7578 33.8283 18.3916 37.2816 20.9974 39.7016C21.4705 38.02 22.4103 36.4943 23.727 35.3025C24.535 34.5712 25.4549 33.9944 26.4434 33.5877C24.6565 32.422 23.4727 30.4053 23.4727 28.1172C23.4727 24.5181 26.4008 21.59 30 21.59C33.5992 21.59 36.5275 24.5181 36.5275 28.1172C36.5275 30.4053 35.3437 32.422 33.5566 33.5877C34.5454 33.9944 35.465 34.5715 36.273 35.3027C37.59 36.4945 38.5295 38.0202 39.0026 39.7018C41.6084 37.2819 43.2422 33.8285 43.2422 31C43.2422 29.8698 45 29.7986 45 31C45 34.0066 43.4397 37.7735 40.6066 40.6066C37.7735 43.4397 34.0066 45 30 45C25.9932 45 22.2265 43.4397 19.3934 40.6066C16.5603 37.7735 15 34.0066 15 30C15 25.9932 16.5603 22.2265 19.3934 19.3934C22.2265 16.5603 25.9932 15 30 15ZM30 34.6445C26.2775 34.6445 23.1473 37.3089 22.5199 40.9211C24.6497 42.3843 27.2264 43.2422 30 43.2422C32.7736 43.2422 35.3503 42.3843 37.4801 40.9211C36.8527 37.3089 33.7228 34.6445 30 34.6445ZM30 23.3478C27.3701 23.3478 25.2306 25.4871 25.2306 28.1172C25.2306 30.7471 27.3701 32.8867 30 32.8867C32.6299 32.8867 34.7694 30.7471 34.7694 28.1172C34.7694 25.4874 32.6299 23.3478 30 23.3478Z",
    fill: "#00A082"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 17,
    width: 2,
    height: 7,
    rx: 1,
    fill: "#00A082"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 24,
    width: 2,
    height: 7,
    rx: 1,
    transform: "rotate(-90 37 24)",
    fill: "#00A082"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeStore);
export default __webpack_public_path__ + "static/media/change-store.0ddef2de5a258891e0063b20d9794bf9.svg";
export { ForwardRef as ReactComponent };